import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useState } from "react";
import { sendDispatchEmail, statusActions } from "../../../components/polizas/form/actions/PolizaActions";
import "./dispatchEmailButton.scss";

var DispatchEmailButton = function DispatchEmailButton(props) {
  var _poliza$contratante, _poliza$contratante3, _poliza$asegurado2, _poliza$beneficiario2, _poliza$contratante4, _poliza$contratante5, _poliza$contratante6, _poliza$asegurado3, _poliza$asegurado4, _poliza$asegurado5, _poliza$beneficiario3, _poliza$beneficiario4, _poliza$beneficiario5;

  var poliza = props.poliza,
      token = props.token,
      _props$contratante_em = props.contratante_emails,
      contratante_emails = _props$contratante_em === void 0 ? [] : _props$contratante_em,
      _props$asegurado_emai = props.asegurado_emails,
      asegurado_emails = _props$asegurado_emai === void 0 ? [] : _props$asegurado_emai,
      _props$beneficiario_e = props.beneficiario_emails,
      beneficiario_emails = _props$beneficiario_e === void 0 ? [] : _props$beneficiario_e;
  var hasContratanteSecondaryEmail = contratante_emails && contratante_emails.some(function (ce) {
    return !ce.is_main;
  });
  var contratanteSecondaryEmails = contratante_emails ? contratante_emails.filter(function (ce) {
    return !ce.is_main;
  }).map(function (ce) {
    return ce.email;
  }) : [];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState({
    todos: false,
    contratante: (_poliza$contratante = poliza.contratante) !== null && _poliza$contratante !== void 0 && _poliza$contratante.email ? true : false,
    asegurado: false,
    beneficiario: false,
    contratante_secondary: hasContratanteSecondaryEmail ? true : false,
    asegurado_secondary: false,
    beneficiario_secondary: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      groupCheckbox = _useState4[0],
      setGroupCheckbox = _useState4[1];

  var hasAseguradoSecondaryEmail = asegurado_emails && asegurado_emails.some(function (ce) {
    return !ce.is_main;
  });
  var hasBeneficiarioSecondaryEmail = beneficiario_emails && beneficiario_emails.some(function (ce) {
    return !ce.is_main;
  });

  var handleCheckboxChange = function handleCheckboxChange(userType) {
    var newGroupCheckbox = _objectSpread(_objectSpread({}, groupCheckbox), {}, _defineProperty({}, userType, !groupCheckbox[userType]));

    if (userType === "todos") {
      var _poliza$contratante2, _poliza$asegurado, _poliza$beneficiario;

      newGroupCheckbox = {
        todos: newGroupCheckbox.todos,
        contratante: (_poliza$contratante2 = poliza.contratante) !== null && _poliza$contratante2 !== void 0 && _poliza$contratante2.email ? newGroupCheckbox.todos : false,
        asegurado: (_poliza$asegurado = poliza.asegurado) !== null && _poliza$asegurado !== void 0 && _poliza$asegurado.email ? newGroupCheckbox.todos : false,
        beneficiario: (_poliza$beneficiario = poliza.beneficiario) !== null && _poliza$beneficiario !== void 0 && _poliza$beneficiario.email ? newGroupCheckbox.todos : false
      };
    } else {
      var allUserIsChecked = newGroupCheckbox.contratante && newGroupCheckbox.asegurado && newGroupCheckbox.beneficiario;
      newGroupCheckbox = _objectSpread(_objectSpread({}, newGroupCheckbox), {}, {
        todos: allUserIsChecked
      });
    }

    setGroupCheckbox(newGroupCheckbox);
  };

  var handleSendEmailButton = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return sendDispatchEmail(poliza === null || poliza === void 0 ? void 0 : poliza.id, groupCheckbox, token);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", (response === null || response === void 0 ? void 0 : response.status) === statusActions.ok && redirectAction());

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              setIsLoading(false);
              console.error(_context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function handleSendEmailButton() {
      return _ref.apply(this, arguments);
    };
  }();

  var redirectAction = function redirectAction() {
    return window.location.href = "/admin/polizas/";
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cntDispatchEmailButton"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    "data-toggle": "modal",
    "data-target": "#exampleModal"
  }, "Enviar email a..."), /*#__PURE__*/React.createElement("div", {
    className: "modal fade",
    id: "exampleModal",
    tabIndex: -1,
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-dialog modal-dialog-centered"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "modal-title",
    id: "exampleModalLabel"
  }, "Enviar email a:", " ", /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")))), /*#__PURE__*/React.createElement("div", {
    className: "modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: groupCheckbox.todos,
    disabled: !((_poliza$contratante3 = poliza.contratante) !== null && _poliza$contratante3 !== void 0 && _poliza$contratante3.email) && !((_poliza$asegurado2 = poliza.asegurado) !== null && _poliza$asegurado2 !== void 0 && _poliza$asegurado2.email) && !((_poliza$beneficiario2 = poliza.beneficiario) !== null && _poliza$beneficiario2 !== void 0 && _poliza$beneficiario2.email),
    onChange: function onChange() {
      return handleCheckboxChange("todos");
    }
  }), "Seleccionar todos los destinatarios"))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: groupCheckbox.contratante,
    disabled: !((_poliza$contratante4 = poliza.contratante) !== null && _poliza$contratante4 !== void 0 && _poliza$contratante4.email),
    onChange: function onChange() {
      return handleCheckboxChange("contratante");
    }
  }), "Contratante (", (_poliza$contratante5 = poliza.contratante) === null || _poliza$contratante5 === void 0 ? void 0 : _poliza$contratante5.name, " -", " ", (_poliza$contratante6 = poliza.contratante) === null || _poliza$contratante6 === void 0 ? void 0 : _poliza$contratante6.email, ")"))), groupCheckbox.contratante && hasContratanteSecondaryEmail && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: function onChange() {
      return handleCheckboxChange("contratante_secondary");
    },
    checked: groupCheckbox.contratante_secondary
  }), "Emails secundarios del Contratante", contratanteSecondaryEmails.length > 0 && " (".concat(contratanteSecondaryEmails.join(", "), ")"))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: groupCheckbox.asegurado,
    disabled: !((_poliza$asegurado3 = poliza.asegurado) !== null && _poliza$asegurado3 !== void 0 && _poliza$asegurado3.email),
    onChange: function onChange() {
      return handleCheckboxChange("asegurado");
    }
  }), "Asegurado (", (_poliza$asegurado4 = poliza.asegurado) === null || _poliza$asegurado4 === void 0 ? void 0 : _poliza$asegurado4.name, " -", " ", (_poliza$asegurado5 = poliza.asegurado) === null || _poliza$asegurado5 === void 0 ? void 0 : _poliza$asegurado5.email, ")"))), groupCheckbox.asegurado && hasAseguradoSecondaryEmail && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: function onChange() {
      return handleCheckboxChange("asegurado_secondary");
    },
    checked: groupCheckbox.asegurado_secondary
  }), "Emails secundarios del Asegurado")))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: groupCheckbox.beneficiario,
    disabled: !((_poliza$beneficiario3 = poliza.beneficiario) !== null && _poliza$beneficiario3 !== void 0 && _poliza$beneficiario3.email),
    onChange: function onChange() {
      return handleCheckboxChange("beneficiario");
    }
  }), "Beneficiario (", (_poliza$beneficiario4 = poliza.beneficiario) === null || _poliza$beneficiario4 === void 0 ? void 0 : _poliza$beneficiario4.name, " -", " ", (_poliza$beneficiario5 = poliza.beneficiario) === null || _poliza$beneficiario5 === void 0 ? void 0 : _poliza$beneficiario5.email, ")"))), groupCheckbox.beneficiario && hasBeneficiarioSecondaryEmail && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: function onChange() {
      return handleCheckboxChange("beneficiario_secondary");
    },
    checked: groupCheckbox.beneficiario_secondary
  }), "Emails secundarios del Beneficiario")))))), /*#__PURE__*/React.createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary",
    "data-dismiss": "modal"
  }, "Cancelar"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    disabled: !(groupCheckbox.contratante || groupCheckbox.asegurado || groupCheckbox.beneficiario) || isLoading,
    onClick: handleSendEmailButton
  }, isLoading ? "Enviando Correos..." : "Enviar emails"))))));
};

export default DispatchEmailButton;